"use strict";

/**
 * Иногда (например, при вставке очень длинного текста в текстовый контейнер)
 * содержимое wizard-content скроллируется до курсора (скролл - событие, которое
 * нельзя отменить).
 *
 * В таких случаях возвращаем скролл на место, чтобы область редактора не оказалась испорченной
 *
 * К сожалению, scroll - событие, которое не всплывает до документа, поэтому ловить
 * его приходится таким образом.
 */

$(document).on(Fotobook.events.ONLINE_EDITOR_STARTED, function(){
    $('.site_content').off('.scroll-fixer').on('scroll', function(event){
        if (event.target.classList.contains('site_content')) {
            if (event.target.scrollTop){
                event.target.scrollTop = 0;
            }
            if (event.target.scrollLeft){
                event.target.scrollLeft = 0;
            }
        }
    });
});
